module.exports = __webpack_public_path__ + "2a39003d.svg";